:host {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
}
